const Config = {
    defaultPath: '/dashboard/default',
    signInPath: '/app/auth/signin',
    basename: '',
    layout: 'vertical',
    subLayout: '',
    collapseMenu: false,
    layoutType: 'menu-light',
    headerBackColor: 'header-blue',
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: false,
    boxLayout: false,
    SERVER_URL: "http://43.204.212.197"
};
export default Config;
